<template>
  <div>
    <el-dialog
      :title="'Renovacion del Contrato: ' + currentActionData.NoContrato"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :close-on-click-modal="true"
    >
      <div class="sub-title">Fecha de compromiso actual:</div>
      <div>
        <el-input
          :placeholder="Pleaseinput"
          v-model="Pleaseinput"
          :disabled="true"
        >
        </el-input>
      </div>
      <br />
      <div class="sub-title">Fecha de compromiso cuando se actualice:</div>
      <div>
        <el-input
          :placeholder="DateToUpdate"
          v-model="DateToUpdate"
          :disabled="true"
        >
        </el-input>
      </div>
      <br />
      <div>
        <div class="sub-title">
          Seleccione cantidad de años a sumar a la fecha de compromiso actual:
        </div>
        <br />
        <el-radio-group v-model="YearsToSum" size="large">
          <el-radio-button label="Años a sumar: " disabled></el-radio-button>
          <el-radio-button label="Sumar 1 año"></el-radio-button>
          <el-radio-button label="Sumar 2 años"></el-radio-button>
          <el-radio-button label="Sumar 3 años"></el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="OpenEvidenceDialog(currentActionData)"
          >Confirm</el-button
        >
      </span>
      <ContractsRenovationEvidenceUpload
        :viewEvidence="viewEvidence"
        :EventData="EventData"
        @OnDocumentSAved="SummitDateRenovation"
        @OnUploadCancelation="OnUploadCancelation"
        :append-to-body="true"
      />
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ContractsRenovationEvidenceUpload from "@/components/activity_flow/CustomerServiceStat/ContractsRenovationEvidenceUpload.vue";

export default {
  name: "ContractsRenovationDialog",
  components: {
    ContractsRenovationEvidenceUpload
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    currentActionData: {
      type: Object,
      default: () => {},
      required: false
    }
  },
  data: () => {
    return {
      YearsToSum: "Años a sumar: ",
      yearsToSum: 0,
      NeedEvidence: true,
      viewEvidence: false,
      EventData: {}
    };
  },

  computed: {
    Pleaseinput() {
      //console.log("currentActionData: ", this.currentActionData);
      return new Date(this.currentActionData.FechaVence).toLocaleDateString();
    },
    DateToUpdate() {
      /*
     console.log(
        "Son iguales: ",
        this.Pleaseinput ===
          moment(new Date(this.Pleaseinput))
            .format()
            .slice(0, -6)
      );
      console.log("Años a sumar: ", this.YearsToSum);
      console.log("FechaToUpdate: ", this.Pleaseinput, typeof this.Pleaseinput);
      console.log("FechaJsToUpdate: ", new Date(this.Pleaseinput));
      console.log(
        "FechaJsAñoToUpdate: ",
        new Date(this.Pleaseinput).getFullYear() + 1
      );
      console.log(
        "FechaJstoSQLToUpdate: ",
        new Date(this.Pleaseinput).toLocaleString("en-US")
      );
      console.log(
        "FechaJstoSQLUsingMomentToUpdate: ",
        moment(new Date(this.Pleaseinput)).format()
      );
      console.log(
        "FechaJstoSQLUsingMoment.Slice()ToUpdate: ",
        moment(new Date(this.Pleaseinput))
          .format()
          .slice(0, -6)
      );
      */
      //let yearsToSum = new Date(this.Pleaseinput).getFullYear()
      let fecha = new Date(this.Pleaseinput);
      let yearsSum = 0;
      switch (this.YearsToSum) {
        case "Años a sumar":
          fecha;
          yearsSum;
          //this. yearsToSum = yearsSum
          break;
        case "Sumar 1 año":
          fecha.setFullYear(fecha.getFullYear() + 1);
          //this.yearsToSum = 1;
          break;
        case "Sumar 2 años":
          fecha.setFullYear(fecha.getFullYear() + 2);
          //this.yearsToSum = 2;
          break;
        case "Sumar 3 años":
          fecha.setFullYear(fecha.getFullYear() + 3);
          //this.yearsToSum = 3;
          break;
        default:
          break;
      }

      return new Date(moment(fecha).format().slice(0, -6)).toLocaleDateString();
    }
  },
  watch: {
    YearsToSum(val) {
      //console.log("yearsToSum: ", val);
      //let fecha = new Date(this.Pleaseinput);
      //let yearsSum = 0;
      switch (val) {
        case "Años a sumar":
          //fecha;
          // yearsSum
          this.yearsToSum = 0;
          break;
        case "Sumar 1 año":
          //fecha.setFullYear(fecha.getFullYear() + 1);
          this.yearsToSum = 1;
          break;
        case "Sumar 2 años":
          //fecha.setFullYear(fecha.getFullYear() + 2);
          this.yearsToSum = 2;
          break;
        case "Sumar 3 años":
          //fecha.setFullYear(fecha.getFullYear() + 3);
          this.yearsToSum = 3;
          break;
        default:
          break;
      }
    }
  },
  methods: {
    handleClose: function () {},

    OpenEvidenceDialog(eventData) {
      /*
      console.log("NeedEvidencebefore if: ", 
        this.NeedEvidence, "OpenEvidenceDialog eventData: ", eventData);
      */
      if (this.NeedEvidence === true) {
        this.viewEvidence = true;
        this.EventData = eventData;
        //console.log("NeedEvidence: ", this.NeedEvidence, "\n View evidence: ", this.viewEvidence);
      }
    },

    async SummitDateRenovation(file, eventData) {
      this.viewEvidence = false;
      /*
      console.log("SummitDateRenovation file:", file, "\nSummitDateRenovation eventData: ", eventData);
      console.log("file.uid: ", file.uid)
      */
      let params = {
        CustomerCode: eventData.ClientCode,
        ContractNo: eventData.NoContrato,
        YearsToSum: this.yearsToSum,
        UpdatedBy: this.currentUser.UserID,
        EvidenceUrl: file.response[0].Url,
        EvidenceUid: file.uid
      };

      await this.$http
        .put("/api/contracts/ContractsDateRenovation", params)
        .then((resp) => {
          resp;
          /*
          console.log("llegue al then");
          console.log("SummitDateRenovation resp: ", resp);
          */
          this.$message({
            type: "success",
            message: "Fecha de contrato renovada exitosamente"
          });
          this.dialogVisible = false;
        })
        .catch((err) => {
          console.error(err);
          this.$message({
            type: "danger",
            message: "error al renovar la fecha del contrato"
          });
        });
      this.$emit("DataSubmited");
    },
    OnUploadCancelation() {
      this.viewEvidence = false;
    }
  }
};
</script>

<style scoped>
el-dialog {
  background-color: blue;
}
</style>
